// extracted by mini-css-extract-plugin
export default {"wrapper":"HdozA","title":"hX81y","button":"bkj1A"};